import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useGetIdentity } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/Loader';

/**
 * Landing route.
 *
 * React-admin sends "/" to the first registered <Resource>, which is Operator
 * Management — a module most admins will not have. Redirect to the first
 * section this particular user may actually open instead, which is the same
 * order the sidebar renders, so the landing page always matches the first tab
 * they can see.
 */
export const HomeRedirect = () => {
  const { data: identity, isLoading } = useGetIdentity();
  const navigate = useNavigate();

  const sections = identity?.sections || [];
  const firstPath = sections.find((section) => section.path)?.path;

  useEffect(() => {
    if (isLoading) return;

    // Profile is granted to everyone, so there is always somewhere to land.
    // If the section list has not arrived yet, wait rather than guessing.
    if (firstPath) {
      navigate(firstPath, { replace: true });
    }
  }, [isLoading, firstPath, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <Loader />
    </Box>
  );
};

export default HomeRedirect;
